import { createFileRoute } from "@tanstack/react-router";

import { getGuidesDirectoryMetadata, GuidesDirectory } from "@/components/guides/guides-directory";

export const Route = createFileRoute("/_home/guides/")({
  component: GuidesDirectory,
  head: () => {
    const metadata = getGuidesDirectoryMetadata();

    return {
      meta: [
        { title: metadata.title },
        { name: "description", content: metadata.description },
        { property: "og:title", content: metadata.title },
        { property: "og:description", content: metadata.description },
        { property: "og:url", content: metadata.ogUrl },
        { property: "twitter:title", content: metadata.title },
        { property: "twitter:description", content: metadata.description },
      ],
    };
  },
});
